import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { roleAuthenticateUserRequest } from "store/actions/auth.actions";
import { toast } from "react-toastify";
import CircularLoader from "../../../../../components/common/CircularLoader/CircularLoader";
import Folder from "components/common/Folder/Folder";
import UploadNewFileModel from "./UploadNewFileModel";
import BulkUploadDocumentModal from "./BulkUploadDocumentModal";
import CreateFolderModel from "./CreateFolderModel";
import Folderr from "../../../../../assets/image14.svg";
import {
  baseURLImage,
  parseBooleanVal,
  sanitizeDocumentUrl,
  capitalizeWords,
  isDocumentFileExpired,
  isDocumentFileExpiringSoon,
} from "../../../../../Utils/utils";
import { BiPlus } from "react-icons/bi";
import { BsUpload, BsFiles } from "react-icons/bs";
import CustomButton from "components/common/Enhansment/Button/CustomButton";
import {
  ChevronRightIcon,
  DownloadIcon,
  HomeIcon,
  UploadIcon,
  TrashIcon,
  FolderIcon,
} from "@heroicons/react/outline";
import { HiOutlineTrash } from "react-icons/hi";
import BreadCrumb from "./BreadCrumb";
import moment from "moment";
import UploadFileTableFolder from "./UploadFileTableFolder";
import EditModel from "./EditModel";
import {
  canAccessDocumentAction,
  canAccessFrontlineMyDocumentsFolderAction,
  DOCUMENT_PERMISSION_ACTIONS,
  isFrontlineEmployeeUser,
  roleAccess,
} from "helpers/RolesPermission";
import {
  PERMISSION_KEYS,
  PERMISSION_KEYS_CHILDREN,
} from "store/constants";
import { USER_ROLE, documentStatus } from "Constants/constant";
import GoogleDocsViewer from "components/common/GoogleDocsViewer";
import { LoginContext } from "helpers/LoginContext";
import { FaFilter } from "react-icons/fa";
import SelectOption from "components/common/Select/Select";
import DocumentComment from "components/common/DocumentComment/DocumentComment";
import GetItemFromLocalstorage from "Utils/GetItemFromLocalstorage";
import ItemMetadata from "../../../../../components/ServiceProvider/Participant/Documents/ItemMetadata";
import { apiDeleteRequest } from "helpers/Requests";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import MoveToParticipantFolderModal, {
  executeMoveToFolder,
  MOVE_ALREADY_IN_DESTINATION,
} from "../../../../../components/ServiceProvider/Participant/Documents/MoveToParticipantFolderModal";
import FilePreviewModal from "../../../../../components/ServiceProvider/Participant/Documents/FilePreviewModal";
import DocumentsHeader from "../../../../../components/ServiceProvider/Participant/Documents/DocumentsHeader";
import RecentFiles from "../../../../../components/ServiceProvider/Participant/Documents/RecentFiles";
import DocumentSkeleton from "../../../../../components/ServiceProvider/Participant/Documents/DocumentSkeleton";
import CheckBox from "components/common/checkBox/checkbox";
import ConfirmationModal from "components/common/Modal/ConfirmationModal";
import {
  findDocumentComplianceSetting,
  isMandatoryDocumentSetting,
} from "./complianceSettingMatch";

const WorkerDocument = (props) => {
  const {
    role = null,
    setUpdatedFile,
    DynamicBreadCrumb,
    createNewFolderSuccess,
    createNewFolderLoading,
    createFolderRequest,
    worker,
    FolderListForHRM,
    FileListForHRM,
    removeFolderRequest,
    removeFileRequest,
    moveDocumentRequest,
    getFolderListForHRMRequest,
    getFolderListForHRMLoading,
    updateFolderRequest,
    workerId = null,
    documentList={},
    isLoading,
    documents,
    setDocuments,
    getDocumentsListForProgressBar,
    getEmployeeDocuments,
    openRequiredModal,
    resetRequiredModalParentCheck,
    requiredDocumentslist,
    requiredDocumentsOnly = false,
    onExitRequiredDocuments = null,
    //Sil Props
    getFolderListForSilRequest,
    silhomeDocumentsListLoader,
    silHomeDocumentFolderList,
    silHomeDocumentFileList,
    silHomeDocumentCreateFolderRequest,
    silHomeDocumentFolderCreateLoader,
    silHomeDocumentUpdateFolderRequest,
    silHomeDocumentUploadFileRequest,
    silHomeDocumentRemoveFileRequest,
    silHomeDocumentRemoveFolderRequest,
    silHomeDocumentFolderUpdateLoader,
  } = props;
  const { isUserGracePeriodOver } = useContext(LoginContext);
  const dispatch = useDispatch();

  const bread = { name: "Required Documents" };
  const REQUIRED_WORKER_DOCS_FOLDER_NAME = "Required Documents";
  const userType = localStorage.getItem("userType");

  /** Worker self-service My Documents (frontline / BLK portal at /documents). */
  const isFrontlineWorkerDocuments = useMemo(
    () => role === "hrm" && isFrontlineEmployeeUser(),
    [role]
  );

  /** Folder grid permissions only — does not affect Required Documents table. */
  const canFrontlineFolderAction = useCallback(
    (action) => {
      if (!isFrontlineWorkerDocuments) {
        return canAccessDocumentAction(role, action);
      }
      return (
        canAccessFrontlineMyDocumentsFolderAction(action) ||
        canAccessDocumentAction(role, action)
      );
    },
    [isFrontlineWorkerDocuments, role]
  );

  const HRM_DOC_CATEGORY_PERMISSIONS = {
    "Qualification/ Required Competency": PERMISSION_KEYS_CHILDREN.HRM.QUALIFICATION,
    "Identification Documents": PERMISSION_KEYS_CHILDREN.HRM.IDENTIFICATION,
    "Financial Documents": PERMISSION_KEYS_CHILDREN.HRM.FINANCIAL,
  };

  const canViewRequiredDocCategory = (categoryName) => {
    const permission = HRM_DOC_CATEGORY_PERMISSIONS[categoryName];
    if (permission) {
      return roleAccess([], PERMISSION_KEYS.HRM, permission);
    }
    // Custom / role-specific compliance categories (e.g. Badsha Salamat)
    return roleAccess([], PERMISSION_KEYS.HRM, PERMISSION_KEYS_CHILDREN.HRM.SHOW);
  };

  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [breadCrumb, setBreadCrumb] = useState([]);
  const [isOpen, setIsopen] = useState(false);
  const [isBulkOpen, setIsBulkOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEditModel, setOpenEditModel] = useState(false);
  const [isOpenCreateFolder, setIsOpenCreateFolder] = useState(false);
  const [isOpenCreateFile, setIsOpenCreateFile] = useState(null);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [showTable, setShowTable] = useState(requiredDocumentsOnly);
  const [updatePermission, setUpdatePermission] = useState(null);
  const [isDocumentUpdateLoading, setIsDocumentUpdateLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [parentId, setParentId] = useState(null);
    const [parentUUID, setParentUUID] = useState(null);
  const [responseData, setResponseData] = useState(null);
  const [fileScore, setFileScore] = useState(0);
  const [filteredStatus, setFilteredStatus] = useState(null);
  const [documentstatus, setdocumentstatus] = useState(documentStatus[0]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [documentComments, setDocumentComments] = useState({});
  const [deletingRequiredDocUuid, setDeletingRequiredDocUuid] = useState(null);
  const [requiredDocPendingDelete, setRequiredDocPendingDelete] =
    useState(null);

  useEffect(() => {
    if (isFrontlineWorkerDocuments && !requiredDocumentsOnly) {
      setShowTable(false);
    }
  }, [isFrontlineWorkerDocuments, requiredDocumentsOnly]);

  useEffect(() => {
    if (isFrontlineWorkerDocuments) {
      dispatch(roleAuthenticateUserRequest());
    }
  }, [dispatch, isFrontlineWorkerDocuments]);

  // Metadata tooltip state - track which item's metadata is showing
  const [metadataItemId, setMetadataItemId] = useState(null);
  const [moveModal, setMoveModal] = useState(null);
  const [isBulkMoveOpen, setIsBulkMoveOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isMoveDropLoading, setIsMoveDropLoading] = useState(false);
  const [moveListRefreshAfterDrop, setMoveListRefreshAfterDrop] = useState(false);
  const sawFolderListLoadingAfterMoveRef = useRef(false);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [sortBy, setSortBy] = useState({ label: "Date (Newest)", value: "date_desc" });
  const [filterBy, setFilterBy] = useState({ label: "All Items", value: "all" });
  const [viewMode, setViewMode] = useState("grid");
  const [selectedItems, setSelectedItems] = useState([]);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Get SP Settings to check if comments are enabled - check multiple sources
  const [spSettingsState, setSpSettingsState] = useState(GetItemFromLocalstorage("spSettings"));
  const [userDataState, setUserDataState] = useState(GetItemFromLocalstorage("user"));
  
  // Update settings when component mounts, when showTable changes, or periodically to get latest values
  // This ensures settings are refreshed after logout/login and browser refresh
  useEffect(() => {
    const updateSettings = () => {
      setSpSettingsState(GetItemFromLocalstorage("spSettings"));
      setUserDataState(GetItemFromLocalstorage("user"));
    };
    
    // Update immediately on mount and when showTable changes
    updateSettings();
    
    // Set up interval to check for settings changes every 1 second
    const interval = setInterval(updateSettings, 1000);
    
    // Listen for storage events (when settings are updated in another tab/window)
    const handleStorageChange = (e) => {
      if (e.key === 'spSettings' || e.key === 'user') {
        updateSettings();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    
    // Update when page becomes visible (user switches back to tab)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        updateSettings();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // Update when window gets focus
    const handleFocus = () => {
      updateSettings();
    };
    window.addEventListener('focus', handleFocus);
    
    // Listen for custom event when user logs in (settings are refreshed)
    const handleLoginRefresh = () => {
      updateSettings();
    };
    window.addEventListener('userLoggedIn', handleLoginRefresh);
    
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userLoggedIn', handleLoginRefresh);
    };
  }, [showTable]);

  // Also refresh settings on component mount (after browser refresh or login)
  useEffect(() => {
    // Refresh settings immediately when component mounts
    setSpSettingsState(GetItemFromLocalstorage("spSettings"));
    setUserDataState(GetItemFromLocalstorage("user"));
  }, []);

  // Calculate settings - recalculate on every render to ensure latest values
  // CRITICAL: Same logic for both SP Admin and Manager - no role-specific differences
  // When toggle is OFF in SP Settings → allowDocumentComments = false → Comments hidden everywhere
  // When toggle is ON in SP Settings → allowDocumentComments = true → Comments visible everywhere
  const spSettings = spSettingsState;
  const userData = userDataState;
  const serviceProviderSettings = userData?.service_provider || {};
  
  // Check both localStorage spSettings and user's service_provider object
  // Backend field name is 'document_comments'
  const documentCommentsFromSpSettings = spSettings?.document_comments;
  const documentCommentsFromServiceProvider = serviceProviderSettings?.document_comments;
  
  // Check document_comments field from either source
  // Priority: serviceProviderSettings > spSettings
  // Handle: true, 1, "1", "true", "yes" as true; false, 0, "0", "false", null, undefined as false
  // Explicitly check for false values first to ensure toggle OFF is recognized
  const isExplicitlyFalse = 
    documentCommentsFromSpSettings === false ||
    documentCommentsFromSpSettings === 0 ||
    documentCommentsFromSpSettings === "0" ||
    documentCommentsFromSpSettings === "false" ||
    documentCommentsFromServiceProvider === false ||
    documentCommentsFromServiceProvider === 0 ||
    documentCommentsFromServiceProvider === "0" ||
    documentCommentsFromServiceProvider === "false";
  
  const allowDocumentComments = isExplicitlyFalse ? false : (
    documentCommentsFromServiceProvider === true ||
    documentCommentsFromServiceProvider === 1 ||
    documentCommentsFromServiceProvider === "1" ||
    documentCommentsFromSpSettings === true ||
    documentCommentsFromSpSettings === 1 ||
    documentCommentsFromSpSettings === "1" ||
    parseBooleanVal(documentCommentsFromServiceProvider) || 
    parseBooleanVal(documentCommentsFromSpSettings) || 
    false
  );

  // Check if user can edit comments (SP Admin or Manager)
  // This is separate from column visibility - column shows if comments are enabled
  const canEditComments = allowDocumentComments && roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]);

  // Load comments from documents when they're fetched
  // Backend returns 'comments' field (not 'comment')
  useEffect(() => {
    if (documents && documents.length > 0) {
      const commentsMap = {};
      documents.forEach((doc) => {
        // Check both 'comment' and 'comments' field names from backend
        // Prioritize 'comment' field, then 'comments' field
        if (doc.comment) {
          commentsMap[doc.name] = doc.comment;
        } else if (doc.comments) {
          commentsMap[doc.name] = doc.comments;
        }
      });
      // Replace all comments with fresh data from documents
      // This ensures updated comments are reflected after re-upload
      setDocumentComments(commentsMap);
    } else if (documents && documents.length === 0) {
      // Clear comments if documents list is empty
      setDocumentComments({});
    }
  }, [documents]);

  // Handle metadata toggle - ensures only one is open at a time
  const handleToggleMetadata = (itemId, isCurrentlyOpen) => {
    if (isCurrentlyOpen) {
      // Close if already open
      setMetadataItemId(null);
    } else {
      // Open this item's metadata (closes any other open one)
      setMetadataItemId(itemId);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 300);
    return () => clearTimeout(timer);
  }, [search]);

  const sortItems = useCallback((items, getName) => {
    return [...items].sort((a, b) => {
      switch (sortBy.value) {
        case "date_asc":
          return new Date(a.updated_at || a.created_at) - new Date(b.updated_at || b.created_at);
        case "date_desc":
          return new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at);
        case "name_asc": {
          const nameA = (getName(a) || "").toLowerCase();
          const nameB = (getName(b) || "").toLowerCase();
          return nameA.localeCompare(nameB);
        }
        case "name_desc": {
          const nameA = (getName(a) || "").toLowerCase();
          const nameB = (getName(b) || "").toLowerCase();
          return nameB.localeCompare(nameA);
        }
        default:
          return new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at);
      }
    });
  }, [sortBy]);

  const displayFolders = useMemo(() => {
    if (showTable) return folders;
    let filtered = sortItems(folders, (item) => item.name);
    if (debouncedSearch) {
      const searchLower = debouncedSearch.toLowerCase();
      filtered = filtered.filter((folder) =>
        (folder.name || "").toLowerCase().includes(searchLower)
      );
    }
    if (filterBy.value === "files") {
      return [];
    }
    if (
      isFrontlineWorkerDocuments &&
      breadCrumb.length === 0
    ) {
      filtered = filtered.filter(
        (folder) =>
          (folder.name || "").trim().toLowerCase() !==
          REQUIRED_WORKER_DOCS_FOLDER_NAME.toLowerCase()
      );
    }
    return filtered;
  }, [
    folders,
    showTable,
    debouncedSearch,
    filterBy,
    sortItems,
    isFrontlineWorkerDocuments,
    breadCrumb.length,
  ]);

  const displayFiles = useMemo(() => {
    if (showTable) return files;
    let filtered = sortItems(files, (item) => item.name || item.label || item.description);
    if (debouncedSearch) {
      const searchLower = debouncedSearch.toLowerCase();
      filtered = filtered.filter((file) => {
        const description = (file.description || "").toLowerCase();
        const name = (file.name || "").toLowerCase();
        const label = (file.label || "").toLowerCase();
        return (
          description.includes(searchLower) ||
          name.includes(searchLower) ||
          label.includes(searchLower)
        );
      });
    }
    if (filterBy.value === "folders") return [];
    if (filterBy.value === "expired") {
      filtered = filtered.filter((file) => isDocumentFileExpired(file));
    } else if (filterBy.value === "expiring_soon") {
      filtered = filtered.filter((file) => isDocumentFileExpiringSoon(file));
    } else if (filterBy.value === "public") {
      filtered = filtered.filter((file) => file.visibility === false);
    } else if (filterBy.value === "private") {
      filtered = filtered.filter((file) => file.visibility === true);
    }
    return filtered;
  }, [files, showTable, debouncedSearch, filterBy, sortItems]);

  const handleCheckboxChange = useCallback((checked, item, type) => {
    setSelectedItems((prev) => {
      const itemId = item.uuid || (type === "folder" ? `folder-${item.id}` : `file-${item.id}`);
      if (checked) {
        return [...prev, { ...item, type, itemId }];
      }
      return prev.filter((selected) => {
        const selectedId =
          selected.uuid ||
          (selected.type === "folder" ? `folder-${selected.id}` : `file-${selected.id}`);
        return selectedId !== itemId;
      });
    });
  }, []);

  const isItemSelected = useCallback(
    (item, type) => {
      const itemId = item.uuid || (type === "folder" ? `folder-${item.id}` : `file-${item.id}`);
      return selectedItems.some((selected) => {
        const selectedId =
          selected.uuid ||
          (selected.type === "folder" ? `folder-${selected.id}` : `file-${selected.id}`);
        return selectedId === itemId;
      });
    },
    [selectedItems]
  );

  const canBulkDeleteFolders = useMemo(() => {
    if (isFrontlineWorkerDocuments) {
      return canFrontlineFolderAction(DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE);
    }
    return (
      canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE) ||
      canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.DELETE)
    );
  }, [role, isFrontlineWorkerDocuments, canFrontlineFolderAction]);

  /** BLK My Documents: one Delete toggle (document.folder.delete) for files and folders. */
  const canBulkDeleteFiles = useMemo(() => {
    if (isFrontlineWorkerDocuments) {
      return canFrontlineFolderAction(DOCUMENT_PERMISSION_ACTIONS.FOLDER_DELETE);
    }
    return canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.DELETE);
  }, [role, isFrontlineWorkerDocuments, canFrontlineFolderAction]);

  const canBulkDelete = canBulkDeleteFolders || canBulkDeleteFiles;

  const canBulkDeleteItem = useCallback(
    (item) => {
      if (item?.type === "folder") {
        return canBulkDeleteFolders;
      }
      return canBulkDeleteFiles;
    },
    [canBulkDeleteFolders, canBulkDeleteFiles]
  );

  const handleBulkDeleteClick = useCallback(() => {
    if (!canBulkDelete) {
      toast.error("You do not have permission to delete documents.");
      return;
    }
    if (selectedItems.length === 0) {
      toast.warning("Please select items to delete.");
      return;
    }
    setShowDeleteConfirm(true);
  }, [canBulkDelete, selectedItems.length]);

  useEffect(() => {
    setSelectedItems([]);
  }, [parentUUID, showTable]);

  // Close metadata when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (metadataItemId && !event.target.closest('[data-metadata-tooltip]')) {
        setMetadataItemId(null);
      }
    };
    
    if (metadataItemId) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [metadataItemId]);

  useEffect(() => {
    if (openRequiredModal === true) {
      setShowTable(true);
      resetRequiredModalParentCheck();
    }
  }, [openRequiredModal]);

  useEffect(() => {
    if (requiredDocumentsOnly) {
      setShowTable(true);
    }
  }, [requiredDocumentsOnly]);

  const handleClickOnRequiredFolder = () => {
    setShowTable(true);
  };

  useEffect(() => {
    if (DynamicBreadCrumb) {
      setBreadCrumb(DynamicBreadCrumb);
    }
  }, [DynamicBreadCrumb]);

  const handleOnFolderClick = (item) => {
    if (role === "sil") {
      getFolderListForSilRequest({
        uuid: (worker && worker.uuid) || worker,
        folder_uuid: item.uuid,
        role: role,
      });
    } else {
      getFolderListForHRMRequest({
        uuid: (worker && worker.uuid) || worker,
        folder_uuid: item.uuid,
        role: role,
      });
    }

    setParentId(item.id);
    setParentUUID(item.uuid);
    setBreadCrumb((prev) => [...prev, item]);
    localStorage.setItem("breadcrumb", JSON.stringify(breadCrumb));
  };

  const getBreadcrumb = (e, index) => {
    setParentId(e.id);
    setParentUUID(e.uuid);
    if (role === "sil") {
      getFolderListForSilRequest({
        uuid: (worker && worker.uuid) || worker,
        folder_uuid: e.uuid,
        role: role,
      });
    } else {
      getFolderListForHRMRequest({
        uuid: (worker && worker.uuid) || worker,
        folder_uuid: e.uuid,
        role: role,
      });
    }
    // Always truncate breadcrumb to the clicked level so UI reflects current path
    const newBreadcrumb = breadCrumb.slice(0, index + 1);
    setBreadCrumb(newBreadcrumb);
    if (newBreadcrumb.length > 0) {
      localStorage.setItem("breadcrumb", JSON.stringify(newBreadcrumb));
    } else {
      localStorage.removeItem("breadcrumb");
    }
  };

  useEffect(() => {
    setBreadCrumb(breadCrumb.slice(0, 1));
    // getDocuments();

    if (role !== "sil") {
      getFolderListForHRMRequest({
        uuid: (worker && worker.uuid) || worker,
        role: role,
      });
    } else {
      getFolderListForSilRequest({
        uuid: (worker && worker.uuid) || worker,
        role: role,
      });
    }
    localStorage.removeItem("breadcrumb");
    setSelectedFile(null);

    return () => {
      localStorage.removeItem("breadcrumb");
    };
  }, []);

  useEffect(() => {
    if (role === "sil") {
      setFiles(
        silHomeDocumentFileList.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        )
      );
    } else {
      setFiles(
        (FileListForHRM || [])
          .filter(Boolean)
          .sort(
            (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
          )
      );
    }
  }, [FileListForHRM, silHomeDocumentFileList]);

  useEffect(() => {
    if (role === "sil") {
      setFolders(
        silHomeDocumentFolderList.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        )
      );
    } else {
      setFolders(
        FolderListForHRM.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        )
      );
    }
  }, [FolderListForHRM, silHomeDocumentFolderList]);

  const getAll = () => {
    if (role === "sil") {
      getFolderListForSilRequest({
        uuid: (worker && worker.uuid) || worker,
        role: role,
      });
    } else {
      getFolderListForHRMRequest({
        uuid: (worker && worker.uuid) || worker,
        role: role,
      });
    }
    setBreadCrumb([]);
    setParentId(null);
    setParentUUID(null);
    setCurrentFolder(null);
    localStorage.removeItem("breadcrumb");
    if (requiredDocumentsOnly && onExitRequiredDocuments) {
      onExitRequiredDocuments();
      return;
    }
    setShowTable(false);
  };

  // const getLabel = (label) => {
  //   if (label) {
  //     return label.substring(label.lastIndexOf("/") + 1, label.length);
  //   }
  //   return ""; // or return a default value if label is null
  // };

  const downloadDoc = (item) => {
    const isExist = documents.find((items) => items.name === item.name);
    if (typeof isExist === "undefined") return;
    else if (isExist && isExist?.link) {
      window.open(sanitizeDocumentUrl(baseURLImage(isExist.link)), "_blank");
    }
  };

  const deleteRequiredUploadedDoc = async (docRow) => {
    if (!docRow?.uuid || isUserGracePeriodOver) return;
    const prefix = isFrontlineEmployeeUser() ? "/hrm" : "/sp";
    setDeletingRequiredDocUuid(docRow.uuid);
    try {
      await apiDeleteRequest(
        `${prefix}/employee-required-document/${docRow.uuid}`,
        {}
      );
      toast.success("Document removed successfully.");
      setRequiredDocPendingDelete(null);
      if (getEmployeeDocuments) await getEmployeeDocuments();
      if (getDocumentsListForProgressBar) getDocumentsListForProgressBar();
    } catch (e) {
      toast.error(e?.message ?? "Could not remove the document.");
    } finally {
      setDeletingRequiredDocUuid(null);
    }
  };

  const closeRequiredDocDeleteModal = () => {
    if (deletingRequiredDocUuid) return;
    setRequiredDocPendingDelete(null);
  };

  useEffect(() => {
    if (responseData) {
      setDocuments([...documents, responseData.data.data]);
      if (documents.length > 0) documents[0].status = false;
      setResponseData(null);
      if (getDocumentsListForProgressBar) getDocumentsListForProgressBar();
    }

    if (updatePermission) {
      const res = files.map((item) =>
        item.id === updatePermission.id ? updatePermission : item
      );
      setFiles(res);
      if (getDocumentsListForProgressBar) getDocumentsListForProgressBar();
    }
    setUpdatePermission(null);
  }, [responseData, documents, updatePermission]);

  useEffect(() => {
    if (isOpenCreateFolder === false) setCurrentFolder(null);
  }, [isOpenCreateFolder]);

  useEffect(() => {
    if (isOpenCreateFile === false) setCurrentFile(null);
  }, [isOpenCreateFile]);

  const isDocumentExpired = (doc) => {
    if (!doc) return false;
    if (doc.is_expire) return true;
    if (!doc.expire_date) return false;
    return moment(doc.expire_date).startOf("day").isSameOrBefore(moment().startOf("day"));
  };

  const getExpiry = (item) => {
    const res = documents.find((items) => {
      return items.name === item.name;
    });
    return isDocumentExpired(res);
  };

  const getExpiryDate = (item) => {
    const res = documents.find((items) => {
      return items.name === item.name;
    });
    if (res?.expire_date) {
      return moment(res?.expire_date).format("DD-MM-YYYY");
    } else {
      return "N/A";
    }
  };

  const getPostedTime = (item) => {
    const res = documents.find((items) => items.name === item.name);
 
    return res?.posted_time || "";
  };

  const getIssueDate = (item) => {
    const res = documents.find((items) => {
      return items.name === item.name;
    });
    if (res?.issue_date) {
      return moment(res?.issue_date).format("DD-MM-YYYY");
    } else {
      return "N/A";
    }
  };

  const handleFetch = (status) => {
    // Implement your handleFetch function
  
  };

  const getAccessToUploadFileAndCreateFolder = () => {
    if (userType === "sp_standard_user" && role === "participant") {
      return true;
    }
    return false;
  };

  const filterOptions = ["All", "Uploaded", "Not Uploaded", "Expired"];

  const filteredDocuments = documentList?.data?.filter((item) => {
    if (!filteredStatus || filteredStatus === "All") {
      return true; // Show all documents if no filter selected or "All" is selected
    }
    if (filteredStatus === "Uploaded") {
      return documents.some((doc) => doc.name === item.name);
    }
    if (filteredStatus === "Not Uploaded") {
      return !documents.some((doc) => doc.name === item.name);
    }
    if (filteredStatus === "Expired") {
      return documents.some((doc) => doc.name === item.name && isDocumentExpired(doc));
    }
    return true;
  });

  const [sortedDocumentList, setSortedDocumentList] = useState({});

  useEffect(() => {
    const hasDocumentList =
      documentList &&
      typeof documentList === "object" &&
      Object.keys(documentList).length > 0;
    if (!hasDocumentList) return;

    const sortedDocumentList = {};
    Object.keys(documentList).forEach((category) => {
      const categoryDocs = documentList[category];
      if (!Array.isArray(categoryDocs)) return;
      const requiredDocuments = [];
      const otherDocuments = [];

      categoryDocs.forEach((doc) => {
        const documentObj = {
          isRequired: false,
          ...doc,
        };
        const isRequired = isMandatoryDocumentSetting(
          documentObj,
          requiredDocumentslist
        );

        if (isRequired) {
          documentObj.isRequired = true;
          requiredDocuments.push(documentObj);
        } else {
          otherDocuments.push(documentObj);
        }
      });

      sortedDocumentList[category] = [...requiredDocuments, ...otherDocuments];
    });

    setSortedDocumentList(sortedDocumentList);
  }, [documentList, requiredDocumentslist]);

  const withComplianceDateRequirements = useCallback(
    (item, extra = {}) => {
      const complianceSource =
        findDocumentComplianceSetting(requiredDocumentslist, item) ||
        findDocumentComplianceSetting(
          Object.values(documentList || {}).flat(),
          item
        );

      return {
        ...item,
        require_issue_date: parseBooleanVal(
          item?.require_issue_date ??
            complianceSource?.require_issue_date ??
            false
        ),
        require_expiry_date: parseBooleanVal(
          item?.require_expiry_date ??
            complianceSource?.require_expiry_date ??
            false
        ),
        ...extra,
      };
    },
    [requiredDocumentslist, documentList]
  );

  const workerCanMoveFolder = useMemo(
    () => canFrontlineFolderAction(DOCUMENT_PERMISSION_ACTIONS.FOLDER_UPDATE),
    [canFrontlineFolderAction]
  );

  const workerCanMoveFile = useMemo(
    () => canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.EDIT),
    [role]
  );

  const canDeleteRequiredDocument = useMemo(
    () => canAccessDocumentAction(role, DOCUMENT_PERMISSION_ACTIONS.DELETE),
    [role]
  );

  const isWorkerDocumentMoveLocked = useCallback(
    (item, type) => {
      if (!isFrontlineWorkerDocuments || role === "sil") {
        return false;
      }
      if (
        type === "folder" &&
        (item?.name || "").trim().toLowerCase() ===
          REQUIRED_WORKER_DOCS_FOLDER_NAME.toLowerCase()
      ) {
        return true;
      }
      if (
        breadCrumb.some(
          (b) =>
            (b?.name || "").trim().toLowerCase() ===
            REQUIRED_WORKER_DOCS_FOLDER_NAME.toLowerCase()
        )
      ) {
        return true;
      }
      return false;
    },
    [breadCrumb, role, isFrontlineWorkerDocuments]
  );

  const isItemSelectableForBulk = useCallback(
    (item, type) => {
      if (!isFrontlineWorkerDocuments) {
        return true;
      }
      if (isWorkerDocumentMoveLocked(item, type)) {
        return false;
      }
      if (type === "folder") {
        return workerCanMoveFolder || canBulkDeleteFolders;
      }
      return workerCanMoveFile || canBulkDeleteFiles;
    },
    [
      isFrontlineWorkerDocuments,
      isWorkerDocumentMoveLocked,
      workerCanMoveFolder,
      workerCanMoveFile,
      canBulkDeleteFolders,
      canBulkDeleteFiles,
    ]
  );

  const bulkSelectableItems = useMemo(() => {
    const folderItems = displayFolders
      .filter((item) => isItemSelectableForBulk(item, "folder"))
      .map((item) => ({
        ...item,
        type: "folder",
        itemId: item.uuid || `folder-${item.id}`,
      }));
    const fileItems = displayFiles
      .filter((item) => isItemSelectableForBulk(item, "file"))
      .map((item) => ({
        ...item,
        type: "file",
        itemId: item.uuid || `file-${item.id}`,
      }));
    return [...folderItems, ...fileItems];
  }, [displayFolders, displayFiles, isItemSelectableForBulk]);

  const canShowBulkSelectionUi = useMemo(() => {
    if (!isFrontlineWorkerDocuments) {
      return true;
    }
    return workerCanMoveFolder || workerCanMoveFile || canBulkDelete;
  }, [
    isFrontlineWorkerDocuments,
    workerCanMoveFolder,
    workerCanMoveFile,
    canBulkDelete,
  ]);

  const handleSelectAll = useCallback(
    (checked) => {
      if (checked) {
        setSelectedItems(bulkSelectableItems);
      } else {
        setSelectedItems([]);
      }
    },
    [bulkSelectableItems]
  );

  const allSelected = useMemo(() => {
    const totalItems = bulkSelectableItems.length;
    if (totalItems === 0) {
      return false;
    }
    return selectedItems.length === totalItems;
  }, [bulkSelectableItems.length, selectedItems.length]);

  const handleOpenMoveModal = useCallback((docItem, docType) => {
    setMoveModal({ item: docItem, type: docType });
  }, []);

  // Selected items the user is allowed to move (respecting permissions + locked folders)
  const selectedMovableItems = useMemo(() => {
    return selectedItems
      .filter((it) => {
        if (isWorkerDocumentMoveLocked(it, it.type)) return false;
        return it.type === "folder" ? workerCanMoveFolder : workerCanMoveFile;
      })
      .map((it) => ({ item: it, itemType: it.type }));
  }, [selectedItems, workerCanMoveFolder, workerCanMoveFile, isWorkerDocumentMoveLocked]);

  const handleBulkMoveClick = useCallback(() => {
    if (selectedMovableItems.length === 0) {
      toast.error("You do not have permission to move the selected items.");
      return;
    }
    setIsBulkMoveOpen(true);
  }, [selectedMovableItems.length]);

  const handleFilePreview = useCallback((fileItem) => {
    if (fileItem && (fileItem.uuid || fileItem.id)) {
      setPreviewFile(fileItem);
      setIsPreviewOpen(true);
    }
  }, []);

  const refreshFolderList = useCallback(() => {
    const w = (worker && worker.uuid) || worker;
    if (!w) return;
    if (role === "sil") {
      getFolderListForSilRequest({
        uuid: w,
        folder_uuid: parentUUID || null,
        role: role,
      });
    } else {
      getFolderListForHRMRequest({
        uuid: w,
        folder_uuid: parentUUID || null,
        role: role,
      });
    }
  }, [worker, parentUUID, role, getFolderListForHRMRequest, getFolderListForSilRequest]);

  // Refetch after create so the new folder appears (same as participant documents).
  useEffect(() => {
    if (!createNewFolderSuccess) return;
    const w = (worker && worker.uuid) || worker;
    if (!w) return;
    if (role === "sil") {
      getFolderListForSilRequest({
        uuid: w,
        folder_uuid: parentUUID || null,
        role: role,
      });
    } else {
      getFolderListForHRMRequest({
        uuid: w,
        folder_uuid: parentUUID || null,
        role: role,
        silentRefresh: true,
      });
    }
  }, [
    createNewFolderSuccess,
    worker,
    parentUUID,
    role,
    getFolderListForHRMRequest,
    getFolderListForSilRequest,
  ]);

  const handleBulkDelete = useCallback(async () => {
    const deletableItems = selectedItems.filter((item) => canBulkDeleteItem(item));
    if (deletableItems.length === 0) {
      setShowDeleteConfirm(false);
      toast.error("You do not have permission to delete the selected items.");
      return;
    }

    setIsBulkDeleting(true);
    setShowDeleteConfirm(false);
    let successCount = 0;
    let errorCount = 0;
    const isSil = role === "sil";
    const removeFolderFn = isSil
      ? silHomeDocumentRemoveFolderRequest
      : removeFolderRequest;
    const removeFileFn = isSil
      ? silHomeDocumentRemoveFileRequest
      : removeFileRequest;

    // SIL actions take (payload, callback); COS puts callback inside payload.
    const runRemove = (fn, payload) =>
      new Promise((resolve, reject) => {
        const onDone = (res, error) => {
          if (error) reject(error);
          else resolve(res);
        };
        if (isSil) {
          fn({ ...payload, skipToast: true }, onDone);
        } else {
          fn({ ...payload, skipToast: true, callback: onDone });
        }
      });

    try {
      const results = await Promise.allSettled(
        deletableItems.map((item) => {
          if (item.type === "folder") {
            const folderId = item.id || item.uuid;
            if (!folderId) {
              return Promise.reject(
                new Error(
                  `Cannot delete folder "${item.name || "Unknown"}": missing identifier`
                )
              );
            }
            return runRemove(removeFolderFn, { folder_id: folderId });
          }
          const fileId = item.id || item.uuid;
          if (!fileId) {
            return Promise.reject(
              new Error(
                `Cannot delete file "${item.name || "Unknown"}": missing identifier`
              )
            );
          }
          return runRemove(removeFileFn, { file_management_id: fileId });
        })
      );

      for (const result of results) {
        if (result.status === "fulfilled") successCount++;
        else {
          console.error("Bulk delete error:", result.reason);
          errorCount++;
        }
      }

      if (successCount > 0) {
        toast.success(
          `${successCount} item${successCount > 1 ? "s" : ""} deleted successfully`
        );
        refreshFolderList();
      }
      if (errorCount > 0) {
        toast.error(
          `${errorCount} item${errorCount > 1 ? "s" : ""} could not be deleted`
        );
      }
      setSelectedItems([]);
    } finally {
      setIsBulkDeleting(false);
    }
  }, [
    canBulkDeleteItem,
    selectedItems,
    role,
    removeFolderRequest,
    removeFileRequest,
    silHomeDocumentRemoveFolderRequest,
    silHomeDocumentRemoveFileRequest,
    refreshFolderList,
  ]);

  const workerEntityUuid = (worker && worker.uuid) || worker;
  const moveDropEnabled = workerCanMoveFile || workerCanMoveFolder;
  const folderListLoadingAfterMove =
    role === "sil" ? Boolean(silhomeDocumentsListLoader) : Boolean(getFolderListForHRMLoading);

  const handleMoveDrop = useCallback(
    async ({ draggedItem, draggedType, targetFolder }) => {
      if (!workerEntityUuid || targetFolder?.id == null) return;
      if (draggedType === "folder" && !workerCanMoveFolder) {
        toast.error("You do not have permission to move folders.");
        return;
      }
      if (draggedType === "file" && !workerCanMoveFile) {
        toast.error("You do not have permission to move files.");
        return;
      }
      if (draggedType === "folder" && draggedItem?.id === targetFolder.id) return;
      if (isWorkerDocumentMoveLocked(draggedItem, draggedType)) return;
      if (isWorkerDocumentMoveLocked(targetFolder, "folder")) return;

      setIsMoveDropLoading(true);
      sawFolderListLoadingAfterMoveRef.current = false;
      setMoveListRefreshAfterDrop(false);

      try {
        const isParticipantRole = role === "participant";
        await executeMoveToFolder({
          item: draggedItem,
          itemType: draggedType,
          targetParentId: targetFolder.id,
          workerUuid:
            role === "sil" || isParticipantRole ? undefined : workerEntityUuid,
          silHomeUuid: role === "sil" ? workerEntityUuid : undefined,
        });
        refreshFolderList();
        setMoveListRefreshAfterDrop(true);
      } catch (e) {
        if (e?.code === MOVE_ALREADY_IN_DESTINATION) {
          toast.info("This item is already in the selected folder.");
        } else {
          const msg =
            e?.response?.data?.message ||
            e?.message ||
            (typeof e === "string" ? e : "Move failed");
          toast.error(msg);
        }
        setIsMoveDropLoading(false);
        setMoveListRefreshAfterDrop(false);
      }
    },
    [
      workerEntityUuid,
      role,
      workerCanMoveFolder,
      workerCanMoveFile,
      isWorkerDocumentMoveLocked,
      refreshFolderList,
    ]
  );

  useEffect(() => {
    if (!moveListRefreshAfterDrop) {
      return undefined;
    }

    if (folderListLoadingAfterMove) {
      sawFolderListLoadingAfterMoveRef.current = true;
    } else if (sawFolderListLoadingAfterMoveRef.current) {
      sawFolderListLoadingAfterMoveRef.current = false;
      setMoveListRefreshAfterDrop(false);
      setIsMoveDropLoading(false);
      return undefined;
    }

    const fallbackMs = 1500;
    const t = setTimeout(() => {
      if (!sawFolderListLoadingAfterMoveRef.current) {
        setMoveListRefreshAfterDrop(false);
        setIsMoveDropLoading(false);
      }
    }, fallbackMs);

    return () => clearTimeout(t);
  }, [folderListLoadingAfterMove, moveListRefreshAfterDrop]);

  // Handle filter change
  const handleFilterChange = (e) => {
    setFilteredStatus(e.target.value);
  };
  // console.log("dataaaaa", worker);
  return (
    <>
      {isOpenCreateFolder && (
        <CreateFolderModel
          role={role}
          setParentId={setParentId}
          parentId={parentId}
          updateFolder={(payload, callback) => {
            if (role === "sil") {
              silHomeDocumentUpdateFolderRequest(payload, callback);
            } else {
              updateFolderRequest(
                payload,
                (response, error) => {
                  // Refresh folder list after successful update to ensure UI shows latest data
                  if (response && !error) {
                    getFolderListForHRMRequest({
                      uuid: (worker && worker.uuid) || worker,
                      folder_uuid: parentUUID || null,
                      role: role,
                    });
                  }
                  
                  // Call the original callback
                  if (callback) {
                    const folderData = response?.data || response;
                    callback(folderData && !error ? folderData : null);
                  }
                }
              );
            }
          }}
          createNewFolderSuccess={createNewFolderSuccess}
          createNewFolderLoading={
            role === "sil"
              ? silHomeDocumentFolderCreateLoader ||
                silHomeDocumentFolderUpdateLoader
              : createNewFolderLoading
          }
          currentFolder={currentFolder}
          setCurrentFolder={setCurrentFolder}
          id={workerId || worker?.id || worker}
          uuid={worker?.uuid}
          createFolderRequest={
            role === "sil"
              ? silHomeDocumentCreateFolderRequest
              : createFolderRequest
          }
          isOpen={isOpenCreateFolder}
          handleClose={setIsOpenCreateFolder}
          isUserGracePeriodOver={isUserGracePeriodOver}
        />
      )}

      {isOpen && (
        <UploadNewFileModel
          role={role}
          setParentId={setParentId}
          parentId={parentId}
          isOpen={isOpen}
          handleClose={setIsopen}
          // documentList={documentList}
          workerId={workerId || worker?.id || worker}
          setUpdatedFile={
            role === "sil" ? silHomeDocumentUploadFileRequest : setUpdatedFile
          }
          isUserGracePeriodOver={isUserGracePeriodOver}
          currentFile={currentFile}
          setCurrentFile={setCurrentFile}
        />
      )}
      {isBulkOpen && (
        <BulkUploadDocumentModal
          role={role}
          parentId={parentId}
          isOpen={isBulkOpen}
          handleClose={setIsBulkOpen}
          workerId={workerId || worker?.id || worker}
          isUserGracePeriodOver={isUserGracePeriodOver}
          silHomeDocumentUploadFileRequest={silHomeDocumentUploadFileRequest}
          onUploadComplete={() => {
            if (role === "sil") {
              getFolderListForSilRequest({
                uuid: (worker && worker.uuid) || worker,
                folder_uuid: parentUUID,
                role: role,
              });
            } else {
              getFolderListForHRMRequest({
                uuid: (worker && worker.uuid) || worker,
                folder_uuid: parentUUID,
                role: role,
              });
            }
          }}
        />
      )}
      {open && (
        <UploadFileTableFolder
          selectedFile={selectedFile}
          SelectedFileName={fileName}
          fileScore={fileScore}
          role={role}
          setUpdatedFile={setResponseData}
          setParentId={setParentId}
          parentId={parentId}
          isOpen={open}
          handleClose={() => {
            setOpen(false);
            setSelectedFile(null);
            if (isFrontlineWorkerDocuments) {
              setShowTable(false);
              refreshFolderList();
              if (getEmployeeDocuments) {
                getEmployeeDocuments();
              }
            } else {
              setShowTable(true);
            }
            setIsDocumentUpdateLoading(false);
          }}
          workerId={workerId || worker?.id || worker}
          isUserGracePeriodOver={isUserGracePeriodOver}
          getEmployeeDocuments={getEmployeeDocuments}
          getDocumentsListForProgressBar={getDocumentsListForProgressBar}
          requiredDocumentslist={requiredDocumentslist}
          onLoadingChange={setIsDocumentUpdateLoading}
        />
      )}
      {openEditModel && (
        <EditModel
          role={role}
          setUpdatedFile={setUpdatedFile}
          setParentId={setParentId}
          parentId={parentId}
          isOpen={openEditModel}
          handleClose={setOpenEditModel}
          workerId={workerId || worker?.id || worker}
          isUserGracePeriodOver={isUserGracePeriodOver}
          currentFile={currentFile}
          fileName={fileName}
          uuid={currentFile?.uuid}
          onModalClose={() => {
            // Reload documents page
            if (role === "sil") {
              getFolderListForSilRequest({
                uuid: (worker && worker.uuid) || worker,
                folder_uuid: parentUUID,
                role: role,
              });
            } else {
              getFolderListForHRMRequest({
                uuid: (worker && worker.uuid) || worker,
                folder_uuid: parentUUID,
                role: role,
              });
            }
          }}

        />
      )}

      <ModalSkeleton
        isOpen={Boolean(requiredDocPendingDelete)}
        closeModal={
          deletingRequiredDocUuid ? undefined : closeRequiredDocDeleteModal
        }
        title='Delete document'
        cssClass='w-[50%]'
        modalFooter={
          <>
            <CustomButton
              label='Cancel'
              variant='secondary'
              isDisabled={Boolean(deletingRequiredDocUuid)}
              clickHandler={closeRequiredDocDeleteModal}
            />
            <CustomButton
              label='Confirm Delete'
              variant='danger'
              isDisabled={Boolean(deletingRequiredDocUuid)}
              showLoading={Boolean(deletingRequiredDocUuid)}
              clickHandler={() => {
                if (requiredDocPendingDelete) {
                  deleteRequiredUploadedDoc(requiredDocPendingDelete);
                }
              }}
            />
          </>
        }
      >
        {requiredDocPendingDelete ? (
          <p className='text-sm text-gray-700'>
            Are you sure you want to delete this required document? This action
            cannot be undone.
          </p>
        ) : null}
      </ModalSkeleton>

      <div className='px-4 sm:px-6 py-4 sm:py-6'>
        <div className='grid grid-cols-1 lg:grid-cols-4 gap-6'>
          {/* Main Content Area - full width (4 cols) when Required Documents table is open, else 3 cols */}
          <div className={`order-2 lg:order-1 w-full min-w-0 ${showTable ? 'lg:col-span-4' : 'lg:col-span-3'}`}>
            {/* Action Buttons */}
            <div className='mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3'>
              <div className='flex items-center gap-2'>
                <h2 className='text-xl font-semibold text-gray-900'>
                  {requiredDocumentsOnly ? "Required Documents" : "Documents"}
                </h2>
                {!showTable && (folders.length > 0 || files.length > 0 || (breadCrumb.length === 0 && role !== "participant" && role !== "sil")) && (() => {
                  const requiredDocCount =
                    breadCrumb.length === 0 &&
                    role !== "participant" &&
                    role !== "sil"
                      ? 1
                      : 0;
                  const totalCount =
                    filterBy.value === "all"
                      ? folders.length + files.length + requiredDocCount
                      : displayFolders.length + displayFiles.length;
                  return (
                    <span className='text-sm text-gray-500'>
                      ({totalCount} {totalCount === 1 ? 'item' : 'items'})
                    </span>
                  );
                })()}
              </div>
              {!showTable && (
                <div className='flex flex-col sm:flex-row gap-3'>
                  {/* Create Folder Button */}
                  {canAccessDocumentAction(
                    role,
                    DOCUMENT_PERMISSION_ACTIONS.FOLDER_CREATE
                  ) && (
                    <CustomButton
                      label='Create Folder'
                      Icon={<BiPlus />}
                      clickHandler={() => {
                        setCurrentFolder(null);
                        setIsOpenCreateFolder(true);
                      }}
                      variant='secondary'
                    />
                  )}
                  
                  {/* Upload Document Button */}
                  {canAccessDocumentAction(
                    role,
                    DOCUMENT_PERMISSION_ACTIONS.UPLOAD
                  ) && (
                    <>
                      <CustomButton
                        label='Bulk Upload'
                        Icon={<BsFiles />}
                        clickHandler={() => {
                          setIsBulkOpen(true);
                        }}
                        variant='secondary'
                      />
                      <CustomButton
                        label='Upload Document'
                        Icon={<BsUpload />}
                        clickHandler={() => {
                          setIsopen(true);
                        }}
                        variant='primary'
                      />
                    </>
                  )}
                </div>
              )}
            </div>

        {/* Main Content */}
        <div className='bg-white border border-gray-200 rounded-xl shadow-lg flex flex-col min-h-0 overflow-hidden'>
          {!showTable && (
            <>
              <DocumentsHeader
                search={search}
                setSearch={setSearch}
                sortBy={sortBy}
                setSortBy={setSortBy}
                filterBy={filterBy}
                setFilterBy={setFilterBy}
                viewMode={viewMode}
                setViewMode={setViewMode}
                showFilters={folders.length > 0 || files.length > 0}
                hideVisibilityFilters={isFrontlineWorkerDocuments}
              />
              {canShowBulkSelectionUi &&
                (displayFolders.length > 0 || displayFiles.length > 0) && (
                <div className='px-4 sm:px-6 py-3 bg-gray-50 border-b border-gray-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3'>
                  <div className='flex items-center gap-2'>
                    <CheckBox
                      handleChange={handleSelectAll}
                      checked={allSelected}
                      cssClass='border-gray-500 rounded-sm'
                    />
                    <span className='text-sm text-gray-700 font-medium'>
                      Select All (
                      {isFrontlineWorkerDocuments
                        ? bulkSelectableItems.length
                        : displayFolders.length + displayFiles.length}{" "}
                      items)
                    </span>
                    {selectedItems.length > 0 && (
                      <span className='text-sm text-gray-500 ml-2'>
                        • {selectedItems.length} selected
                      </span>
                    )}
                  </div>
                  {selectedItems.length > 0 && (
                    <div className='flex items-center gap-2 flex-shrink-0'>
                      <button
                        onClick={() => setSelectedItems([])}
                        className='text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors px-3 py-1.5 rounded-md hover:bg-gray-200 border border-gray-300 whitespace-nowrap'
                        disabled={isBulkDeleting}
                      >
                        Clear Selection
                      </button>
                      {selectedMovableItems.length > 0 && (
                        <CustomButton
                          label={`Move ${selectedMovableItems.length}`}
                          Icon={<FolderIcon className='h-4 w-4' />}
                          clickHandler={handleBulkMoveClick}
                          variant='secondary'
                          isDisabled={isBulkDeleting}
                          cssClass='min-w-[100px]'
                        />
                      )}
                      {selectedItems.some((item) => canBulkDeleteItem(item)) && (
                        <CustomButton
                          label={`Delete ${selectedItems.filter((item) => canBulkDeleteItem(item)).length}`}
                          Icon={<TrashIcon className='h-4 w-4' />}
                          clickHandler={handleBulkDeleteClick}
                          variant='danger'
                          showLoading={isBulkDeleting}
                          isDisabled={isBulkDeleting}
                          cssClass='min-w-[100px]'
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
          {/* Breadcrumb Section */}
          {showTable || breadCrumb.length > 0 ? (
            <div className='px-4 sm:px-6 py-4 bg-gray-50 border-b border-gray-200'>
              <nav>
                <ol className='flex flex-wrap items-center gap-2 sm:gap-4'>
                  <button onClick={getAll} className='cursor-pointer'>
                    <span className='text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors'>
                      All Documents
                    </span>
                  </button>
                  {showTable && (
                    <div className='text-gray-400'>
                      <BreadCrumb breadCrumb={bread} index={2} key={2} />
                    </div>
                  )}
                  {breadCrumb.length > 0 && (
                    <span>
                      <ChevronRightIcon
                        className='flex-shrink-0 h-4 w-4 text-gray-400'
                        aria-hidden='true'
                      />
                    </span>
                  )}
                  {breadCrumb.length >= 4 && (
                    <>
                      <b className='mb-2'>...</b>
                      <span className='ml-0'>
                        <ChevronRightIcon
                          className='flex-shrink-0 h-4 w-4 text-gray-400'
                          aria-hidden='true'
                        />
                      </span>
                    </>
                  )}
                  {breadCrumb
                    .slice(breadCrumb.length >= 4 ? -2 : 0)
                    .map((item, index) => {
                      const actualIndex = breadCrumb.length >= 4 
                        ? breadCrumb.length - 2 + index 
                        : index;
                      const isFirstVisibleInCollapsed = breadCrumb.length >= 4 && index === 0;
                      return (
                        <BreadCrumb
                          breadCrumb={item}
                          index={actualIndex}
                          key={index}
                          handleClick={getBreadcrumb}
                          showLeadingArrow={!isFirstVisibleInCollapsed}
                        />
                      );
                    })}
                </ol>
              </nav>
            </div>
          ) : null}
          {getFolderListForHRMLoading || silhomeDocumentsListLoader || (requiredDocumentsOnly && (isLoading || isDocumentUpdateLoading)) ? (
            <div className='p-4 sm:p-6'>
              {!showTable ? (
                <DocumentSkeleton count={8} />
              ) : (
                <CircularLoader classes='flex justify-center items-center' />
              )}
            </div>
          ) : (
            <>
              {showTable ? (
                        <div className='bg-white w-full max-w-full min-w-0 px-4 sm:px-6 lg:px-8 pb-10 pt-4 custom-scroll flex-1 min-h-0 max-h-[70vh] overflow-y-auto'>
                          {
                            role === "participant" ||
                            requiredDocumentsOnly ||
                            roleAccess(
                                [],
                                PERMISSION_KEYS.HRM,
                                PERMISSION_KEYS_CHILDREN.HRM.QUALIFICATION
                            ) || roleAccess(
                                [],
                                PERMISSION_KEYS.HRM,
                                PERMISSION_KEYS_CHILDREN.HRM.IDENTIFICATION
                            ) || roleAccess(
                                [],
                                PERMISSION_KEYS.HRM,
                                PERMISSION_KEYS_CHILDREN.HRM.FINANCIAL
                            ) ? (
                          <>
                          <div className='flex flex-col sm:flex-row sm:justify-end sm:items-center gap-3 mb-4 pb-4 border-b border-gray-200'>
                            <span className='text-sm font-semibold text-gray-700 flex items-center gap-2'>
                              <FaFilter className='text-gray-500' />
                              Document filter by status
                            </span>
                            <div className='w-full sm:w-[200px]'>
                              <SelectOption
                                isSearch={false}
                                selectedOption={documentstatus}
                                handleChange={(e) => {
                                  setdocumentstatus(e);
                                  handleFetch({ status: e.value });
                                }}
                                data={documentStatus}
                              />
                            </div>
                          </div>

                          <div className='flex flex-col w-full min-w-0'>
                            <div className='w-full min-w-0 overflow-x-auto custom-scroll' role='region' aria-label='Mandatory documents table'>
                              <div className='inline-block min-w-full py-2 align-middle'>
                                <div className='bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden'>
                                  <table className='w-full divide-y divide-gray-200' style={{ minWidth: '900px' }}>
                                    <thead className='bg-gray-50 sticky top-0 z-[7] border-b border-gray-200 capitalize'>
                                      <tr className=''>
                                        <th scope='col' className='px-2 py-2 text-left text-xs font-semibold text-gray-900 sm:px-3 sm:py-3.5 sm:text-sm whitespace-nowrap' style={{ minWidth: '180px' }}>
                                          Mandatory Documents
                                        </th>
                                        <th scope='col' className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900 whitespace-nowrap' style={{ minWidth: '100px' }}>
                                          Status
                                        </th>
                                        <th scope='col' className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900 whitespace-nowrap' style={{ minWidth: '90px' }}>
                                          Issue Date
                                        </th>
                                        <th scope='col' className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900 whitespace-nowrap' style={{ minWidth: '90px' }}>
                                          Expiry Date
                                        </th>
                                        <th scope='col' className='hidden md:table-cell px-2 py-2 text-left text-xs font-semibold text-gray-900 sm:px-3 sm:py-3.5 sm:text-sm whitespace-nowrap' style={{ minWidth: '90px' }}>
                                          Uploaded At
                                        </th>
                                        {allowDocumentComments && (
                                          <th scope='col' className='px-3 py-3.5 text-left text-sm font-semibold text-gray-900 whitespace-nowrap' style={{ minWidth: '140px', width: '140px' }}>
                                            Comments
                                          </th>
                                        )}
                                        <th scope='col' className='px-3 py-3.5 text-center text-sm font-semibold text-gray-900 whitespace-nowrap sticky right-0 bg-gray-50 z-[7] border-b border-gray-200' style={{ minWidth: '140px', width: '140px' }}>
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200 bg-white'>
                                    {sortedDocumentList && Object.keys(sortedDocumentList).length > 0 ? (
                                        Object.keys(sortedDocumentList).map((category) => {
                                          let docs = sortedDocumentList[category];
                                          if (
                                            role !== "participant" &&
                                            !requiredDocumentsOnly &&
                                            !canViewRequiredDocCategory(category)
                                          ) {
                                            docs = [];
                                          }

                                          const hasVisibleDocs = docs.some(item => {
                                            const status = getExpiry(item) === true
                                                ? "Expired"
                                                : documents.find(items => items.name === item.name)
                                                    ? "Uploaded"
                                                    : "Not Uploaded";

                                            return (!documentstatus.value && status !== "Expired") ||
                                                documentstatus.value === "all" ||
                                                (documentstatus.value === "uploaded" && status === "Uploaded") ||
                                                (documentstatus.value === "notuploaded" && status === "Not Uploaded") ||
                                                (documentstatus.value === "expired" && status === "Expired");
                                          });

                                          if (!hasVisibleDocs) return null;

                                          return (
                                              <React.Fragment key={`category-${category}`}>
                                                <tr className="bg-gray-100">
                                                  <td colSpan={allowDocumentComments ? "7" : "6"} className="py-2 px-2 text-left font-bold text-xl bg-[#EFF6FF]">
                                                    {capitalizeWords(category)}
                                                  </td>
                                                </tr>

                                                {docs.map((item, index) => {
                                                  const status = getExpiry(item) === true
                                                      ? "Expired"
                                                      : documents.find(items => items.name === item.name)
                                                          ? "Uploaded"
                                                          : "Not Uploaded";

                                                  if (
                                                      (!documentstatus.value && status !== "Expired") ||
                                                      documentstatus.value === "all" ||
                                                      (documentstatus.value === "uploaded" && status === "Uploaded") ||
                                                      (documentstatus.value === "notuploaded" && status === "Not Uploaded") ||
                                                      (documentstatus.value === "expired" && status === "Expired")
                                                  ) {
                                                    return (
                                                        <tr
                                                            className='even:bg-white odd:bg-gray-50'
                                                            key={`${category}-${index}`}
                                                        >
                                                          <td className='whitespace-normal break-words py-3 px-2 text-left text-xs font-medium text-gray-900 sm:px-3 sm:py-4 sm:text-sm'>
                                                            {capitalizeWords(item?.name)} {item?.isRequired ? <span className='text-red-500'>*</span> : ""} 
                                                          </td>
                                                          <td className='whitespace-normal break-words px-2 py-3 text-left text-xs text-gray-500 sm:px-3 sm:py-4 sm:text-sm'>
                                                            {status}
                                                          </td>
                                                          <td className='hidden sm:table-cell whitespace-normal break-words px-2 py-3 text-left text-xs text-gray-500 sm:px-3 sm:py-4 sm:text-sm'>
                                                            {getIssueDate(item)}
                                                          </td>
                                                          <td className='hidden sm:table-cell whitespace-normal break-words px-2 py-3 text-left text-xs text-gray-500 sm:px-3 sm:py-4 sm:text-sm'>
                                                            {getExpiryDate(item)}
                                                          </td>
                                                          <td className='hidden md:table-cell whitespace-normal break-words px-2 py-3 text-left text-xs text-gray-500 sm:px-3 sm:py-4 sm:text-sm'>
                                                            {getPostedTime(item)}
                                                          </td>
                                                          {allowDocumentComments && (
                                                            <td className='px-2 py-3 text-left text-xs text-gray-500 sm:px-3 sm:py-4 sm:text-sm w-[200px] max-w-[200px] overflow-hidden' style={{ width: '200px', maxWidth: '200px' }}>
                                                              <DocumentComment
                                                                key={`${item.name}-${documents.find(doc => doc.name === item.name)?.uuid || ''}-${documents.find(doc => doc.name === item.name)?.updated_at || ''}`}
                                                                documentUuid={documents.find(doc => doc.name === item.name)?.uuid}
                                                                documentName={item.name}
                                                                profileId={worker?.uuid || worker}
                                                                initialComment={documents.find(doc => doc.name === item.name)?.comment || documents.find(doc => doc.name === item.name)?.comments || documentComments[item.name] || ""}
                                                                isEditable={false}
                                                                onCommentSaved={(comment) => {
                                                                  setDocumentComments(prev => ({
                                                                    ...prev,
                                                                    [item.name]: comment
                                                                  }));
                                                                  if (getEmployeeDocuments) {
                                                                    getEmployeeDocuments();
                                                                  }
                                                                }}
                                                              />
                                                            </td>
                                                          )}
                                                          <td 
                                                            className='whitespace-nowrap px-2 py-3 text-xs text-center text-gray-500 sm:px-3 sm:py-4 sm:text-sm sticky right-0 z-[6] align-top'
                                                            style={{ minWidth: '168px', width: '168px' }}
                                                          >
                                                            <div className='flex justify-center items-center space-x-1 w-full relative z-10'>
                                                              <div
                                                                  onClick={() => {
                                                                    const res = documents.find(
                                                                        items => items.name === item.name
                                                                    );

                                                                    if (!res || isDocumentExpired(res)) {
                                                                      setSelectedFile(
                                                                        withComplianceDateRequirements(item)
                                                                      );
                                                                      setFileName(item.name);
                                                                      setFileScore(item.score);
                                                                      setOpen(true);
                                                                    } else if (res) {
                                                                      const isExist = documents.find(
                                                                          items => items.name === item.name
                                                                      );
                                                                      const obj = {};
                                                                      if (typeof isExist === "undefined") {
                                                                      } else if (isExist) {
                                                                        Object.assign(obj, {
                                                                          issue_date: isExist.issue_date,
                                                                          expire_date: isExist.expire_date,
                                                                          docuemnt_id: isExist.id,
                                                                          is_expire: isExist.is_expire,
                                                                          link: sanitizeDocumentUrl(baseURLImage(isExist?.link)),
                                                                          comment: isExist.comment || isExist.comments || documentComments[item.name] || "",
                                                                        });
                                                                      }
                                                                      setSelectedFile(
                                                                        withComplianceDateRequirements(
                                                                          item,
                                                                          obj
                                                                        )
                                                                      );
                                                                      setFileName(item.name);
                                                                      setFileScore(item.score);
                                                                      setOpen(true);
                                                                    }
                                                                  }}
                                                                  className='icon-upload-wrapper'
                                                                  title='upload'
                                                              >
                                                                <UploadIcon className='icon-size' />
                                                              </div>

                                                              <div className='w-2'></div>

                                                              <div className='gap-x-3 flex'>
                                                                <GoogleDocsViewer
                                                                    url={baseURLImage(
                                                                        documents.find(
                                                                            doc => doc.name === item.name
                                                                        )?.link
                                                                    )}
                                                                />
                                                              </div>

                                                              <div className='w-2'></div>

                                                              <div
                                                                  className={`icon-download-wrapper ${
                                                                      documents.find(
                                                                          items => items.name === item.name
                                                                      )
                                                                          ? ""
                                                                          : "opacity-40 cursor-not-allowed"
                                                                  }`}
                                                                  title='Download'
                                                                  onClick={() => downloadDoc(item)}
                                                              >
                                                                <DownloadIcon className='icon-size' />
                                                              </div>

                                                              <div className='w-2'></div>

                                                              {(() => {
                                                                const uploadedRow = documents.find(
                                                                  (d) => d.name === item.name
                                                                );
                                                                const hasUpload = Boolean(uploadedRow);
                                                                const isBusy =
                                                                  deletingRequiredDocUuid === uploadedRow?.uuid;
                                                                const deleteModalOpen =
                                                                  Boolean(requiredDocPendingDelete);
                                                                return (
                                                                  <>
                                                                    {canDeleteRequiredDocument && (
                                                                    <button
                                                                      type='button'
                                                                      disabled={
                                                                        !hasUpload ||
                                                                        isBusy ||
                                                                        deleteModalOpen ||
                                                                        isUserGracePeriodOver
                                                                      }
                                                                      className={
                                                                        !hasUpload ||
                                                                        isBusy ||
                                                                        deleteModalOpen ||
                                                                        isUserGracePeriodOver
                                                                          ? "opacity-40 cursor-not-allowed"
                                                                          : ""
                                                                      }
                                                                      onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (
                                                                          !hasUpload ||
                                                                          isBusy ||
                                                                          deleteModalOpen ||
                                                                          isUserGracePeriodOver
                                                                        )
                                                                          return;
                                                                        setRequiredDocPendingDelete(
                                                                          uploadedRow
                                                                        );
                                                                      }}
                                                                    >
                                                                      <div
                                                                        className='icon-delete-wrapper'
                                                                        title={
                                                                          hasUpload
                                                                            ? "Delete"
                                                                            : "No document to remove"
                                                                        }
                                                                      >
                                                                        <HiOutlineTrash className='icon-size' />
                                                                      </div>
                                                                    </button>
                                                                    )}
                                                                  </>
                                                                );
                                                              })()}
                                                            </div>
                                                          </td>
                                                        </tr>
                                                    );
                                                  }
                                                  return null;
                                                })}
                                              </React.Fragment>
                                          );
                                        })
                                    ) : (

                                        <tr>
                                          <td
                                              colSpan={allowDocumentComments ? '7' : '6'}
                                              className='py-4 px-3 text-sm font-medium text-gray-900 text-center'
                                          >
                                            No data found!
                                          </td>
                                        </tr>
                                    )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          </>
                            ) : (
                                <></>
                            )}
                        </div>
              ) : (
                <div className='relative custom-scroll flex-1 min-h-0 max-h-[70vh] overflow-y-auto p-4 sm:p-6'>
                  {isMoveDropLoading && (
                    <div
                      className='absolute inset-0 z-[80] flex items-center justify-center rounded-lg bg-white/85 backdrop-blur-[1px]'
                      aria-live='polite'
                      aria-busy='true'
                    >
                      <CircularLoader classes='flex justify-center items-center' />
                    </div>
                  )}
                  <div
                    className={`grid gap-4 capitalize overflow-visible ${
                      isFrontlineWorkerDocuments
                        ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
                        : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
                    }`}
                  >
                            {breadCrumb.length === 0 &&
                              role !== "participant" &&
                              role !== "sil" && (
                                <div
                                  className='border border-gray-200 shadow-sm rounded-xl bg-white hover:shadow-md transition-shadow cursor-pointer p-5'
                                  onClick={handleClickOnRequiredFolder}
                                >
                                  <div className='flex flex-col items-start'>
                                    <div className='flex justify-between w-full items-center mb-4'>
                                      <div className='h-12 w-12 rounded-lg bg-purple-100 flex items-center justify-center'>
                                        <img
                                          src={Folderr}
                                          alt='image_folder'
                                          className='h-8 w-8'
                                        />
                                      </div>
                                    </div>
                                    <div className='w-full'>
                                      <div className='text-gray-900 font-semibold text-sm leading-5 truncate w-full'>
                                        Required Documents
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                          {displayFolders.length > 0 &&
                            displayFolders.map((item, index) => (
                              <div key={item.uuid || `folder-${item.id}`} className='relative z-0 overflow-hidden'>
                                {!showTable &&
                                  canShowBulkSelectionUi &&
                                  isItemSelectableForBulk(item, "folder") && (
                                  <div
                                    className='absolute top-2 left-2 z-[1] bg-white rounded p-1 shadow-sm'
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <CheckBox
                                      handleChange={(checked) =>
                                        handleCheckboxChange(checked, item, "folder")
                                      }
                                      checked={isItemSelected(item, "folder")}
                                      cssClass='border-gray-500 rounded-sm'
                                    />
                                  </div>
                                )}
                              <Folder
                                role={role}
                                fileViewContext={role === "sil" ? undefined : "worker"}
                                permissionRename={getAccessToUploadFileAndCreateFolder()}
                                onClick={() => handleOnFolderClick(item)}
                                onFileClick={handleFilePreview}
                                createdDate={item.created_at}
                                type='folder'
                                badged={item.badged}
                                label={item.name}
                                item={item}
                                viewMode={viewMode}
                                isLockedFolder={isWorkerDocumentMoveLocked(
                                  item,
                                  "folder"
                                )}
                                removeFolder={
                                  role === "sil"
                                    ? silHomeDocumentRemoveFolderRequest
                                    : removeFolderRequest
                                }
                                removeFile={
                                  role === "sil"
                                    ? silHomeDocumentRemoveFileRequest
                                    : removeFileRequest
                                }
                                isEdit={(e) => setIsOpenCreateFolder(e)}
                                currentFolder={(e) => setCurrentFolder(e)}
                                metadataItemId={metadataItemId}
                                onToggleMetadata={handleToggleMetadata}
                                enableMoveToFolder={
                                  canFrontlineFolderAction(
                                    DOCUMENT_PERMISSION_ACTIONS.FOLDER_UPDATE
                                  ) && !isWorkerDocumentMoveLocked(item, "folder")
                                }
                                onMoveToFolder={handleOpenMoveModal}
                                onMoveDrop={
                                  moveDropEnabled && !isWorkerDocumentMoveLocked(item, "folder")
                                    ? handleMoveDrop
                                    : undefined
                                }
                              />
                              </div>
                            ))}
                          {displayFiles.length > 0 &&
                            displayFiles.map((item, index) => (
                              <div key={item.uuid || `file-${item.id}`} className='relative z-0 overflow-hidden'>
                                {!showTable &&
                                  canShowBulkSelectionUi &&
                                  isItemSelectableForBulk(item, "file") && (
                                  <div
                                    className='absolute top-2 left-2 z-[1] bg-white rounded p-1 shadow-sm'
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <CheckBox
                                      handleChange={(checked) =>
                                        handleCheckboxChange(checked, item, "file")
                                      }
                                      checked={isItemSelected(item, "file")}
                                      cssClass='border-gray-500 rounded-sm'
                                    />
                                  </div>
                                )}
                              <Folder
                                isUserGracePeriodOver={isUserGracePeriodOver}
                                ext={item?.file_type}
                                fileViewContext={role === "sil" ? undefined : "worker"}
                                setUpdatePermission={setUpdatePermission}
                                createdDate={item.created_at}
                                type='file'
                                role={role}
                                onFileClick={handleFilePreview}
                                badged='Expiry'
                                label={item?.name ?? item?.link}
                                item={item}
                                viewMode={viewMode}
                                removeFolder={
                                  role === "sil"
                                    ? silHomeDocumentRemoveFolderRequest
                                    : removeFolderRequest
                                }
                                removeFile={
                                  role === "sil"
                                    ? silHomeDocumentRemoveFileRequest
                                    : removeFileRequest
                                }
                                isEditt={(e) => setOpenEditModel(e)}
                                currentFile={(e) => setCurrentFile(e)}
                                metadataItemId={metadataItemId}
                                onToggleMetadata={handleToggleMetadata}
                                enableMoveToFolder={
                                  workerCanMoveFile &&
                                  !isWorkerDocumentMoveLocked(item, "file")
                                }
                                onMoveToFolder={handleOpenMoveModal}
                                onMoveDrop={
                                  moveDropEnabled && !isWorkerDocumentMoveLocked(item, "file")
                                    ? handleMoveDrop
                                    : undefined
                                }
                              />
                              </div>
                            ))}
                          
                          {displayFolders.length === 0 &&
                          displayFiles.length === 0 &&
                          role === "participant" &&
                          breadCrumb.length === 0 ? (
                            <div className='col-span-full w-full min-h-[280px] flex flex-col items-center justify-center py-12'>
                              <div className='flex flex-col items-center gap-2'>
                                <div className='w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center'>
                                  <svg className='w-8 h-8 text-gray-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                  </svg>
                                </div>
                                <p className='font-medium text-gray-500 text-center'>No documents found</p>
                                <p className='text-sm text-gray-400 text-center'>Create a folder or upload a document to get started</p>
                              </div>
                            </div>
                          ) : (
                            displayFolders.length === 0 &&
                            displayFiles.length === 0 &&
                            breadCrumb.length !== 0 && (
                              <div className='col-span-full w-full min-h-[280px] flex flex-col items-center justify-center py-12'>
                                <div className='flex flex-col items-center gap-2'>
                                  <div className='w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center'>
                                    <svg className='w-8 h-8 text-gray-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
                                    </svg>
                                  </div>
                                  <p className='font-medium text-gray-500 text-center'>This folder is empty</p>
                                  <p className='text-sm text-gray-400 text-center'>Upload files or create subfolders to organize documents</p>
                                </div>
                              </div>
                            )
                          )}
                          {displayFolders.length === 0 &&
                            displayFiles.length === 0 &&
                            filterBy.value !== "all" &&
                            (folders.length > 0 || files.length > 0) && (
                              <div className='col-span-full w-full min-h-[200px] flex flex-col items-center justify-center py-10'>
                                <p className='font-medium text-gray-500 text-center'>
                                  No documents match the selected filter
                                </p>
                                <p className='text-sm text-gray-400 text-center mt-1'>
                                  Try another filter or open a subfolder
                                </p>
                              </div>
                            )}
                        </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        
        {/* Sidebar for Item Metadata - hidden when Required Documents table is open so table uses full width */}
        <div className={`order-1 lg:order-2 space-y-6 ${showTable ? 'hidden' : 'lg:col-span-1'}`}>
          <RecentFiles
            files={files}
            folders={folders}
            onFileClick={handleFilePreview}
            onFolderClick={handleOnFolderClick}
            maxItems={5}
          />
          {/* Item Metadata */}
          {metadataItemId && (() => {
            // Find the item in folders or files
            const folderItem = folders.find(f => (f.uuid || `folder-${f.id}`) === metadataItemId);
            const fileItem = files.find(f => (f.uuid || `file-${f.id}`) === metadataItemId);
            const item = folderItem || fileItem;
            const type = folderItem ? "folder" : "file";
            
            return item ? (
              <ItemMetadata
                item={item}
                type={type}
                onClose={() => setMetadataItemId(null)}
                showFileVisibility={!isFrontlineWorkerDocuments}
              />
            ) : null;
          })()}
        </div>
      </div>
      </div>

      <ConfirmationModal
        showModal={showDeleteConfirm}
        closeModalHandler={() => setShowDeleteConfirm(false)}
        submitHandler={handleBulkDelete}
        title='Confirm Delete'
        heading={`Are you sure you want to delete ${selectedItems.length} item${selectedItems.length !== 1 ? "s" : ""}?`}
        isNew={true}
        cancelBtnLabel='Cancel'
        confirmBtnLabel='Delete'
        variantConfirmBtn='danger'
        confirmBtnLoader={isBulkDeleting}
      />

      <FilePreviewModal
        isOpen={isPreviewOpen}
        onClose={() => {
          setIsPreviewOpen(false);
          setPreviewFile(null);
        }}
        fileItem={previewFile}
        role={role}
        fileViewContext={role === "sil" ? undefined : "worker"}
        allFiles={files}
      />

      <MoveToParticipantFolderModal
        open={Boolean(moveModal)}
        onClose={() => setMoveModal(null)}
        participantUuid={role === "participant" ? (worker && worker.uuid) || worker : undefined}
        workerUuid={role === "sil" ? undefined : (worker && worker.uuid) || worker}
        silHomeUuid={role === "sil" ? (worker && worker.uuid) || worker : undefined}
        item={moveModal?.item}
        itemType={moveModal?.type}
        moveDocumentRequest={moveDocumentRequest}
        onSuccess={refreshFolderList}
      />

      {isBulkMoveOpen && (
        <MoveToParticipantFolderModal
          open
          onClose={() => setIsBulkMoveOpen(false)}
          participantUuid={role === "participant" ? (worker && worker.uuid) || worker : undefined}
          workerUuid={role === "sil" ? undefined : (worker && worker.uuid) || worker}
          silHomeUuid={role === "sil" ? (worker && worker.uuid) || worker : undefined}
          bulkItems={selectedMovableItems}
          moveDocumentRequest={moveDocumentRequest}
          onSuccess={() => {
            refreshFolderList();
            setSelectedItems([]);
          }}
        />
      )}
    </>
  );
};

export default WorkerDocument;
